(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["w"] = factory(require("vue"));
	else
		root["w"] = root["w"] || {}, root["w"]["button"] = factory(root["Vue"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__895__) {
return 